import { useState } from 'react';
import { ImportWizardModal } from './Modals';
import ActionsMenu from '../../../components/ActionsMenu';

/**
 * RuleImporter - Wrapper component for the import wizard
 * @param {Object} props - Component props
 * @param {Function} props.onImportComplete - Callback when import is complete
 * @param {Array} props.families - Array of family objects
 * @param {Array} props.featuresMetadata - Array of feature metadata
 * @param {string|number} props.activeFamilyId - Currently active family ID
 * @returns {JSX.Element} - Rendered rule importer component
 */
export default function RuleImporter({ onImportComplete, families, featuresMetadata, activeFamilyId }) {
  const [isWizardOpen, setIsWizardOpen] = useState(false);

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <ActionsMenu
          label="Rule import actions"
          items={[
            {
              label: 'Import Wizard',
              icon: 'fa-solid fa-file-import',
              onSelect: () => setIsWizardOpen(true)
            }
          ]}
        />
      </div>
      {isWizardOpen && (
        <ImportWizardModal 
          show={isWizardOpen} 
          onClose={() => setIsWizardOpen(false)} 
          onImportComplete={onImportComplete}
          families={families}
          featuresMetadata={featuresMetadata}
          activeFamilyId={activeFamilyId}
        />
      )}
    </>
  );
}
